export default "__VITE_ASSET__CipJ7$aH__"